const style = {
  marginTop30: { marginTop: '30px' },
  imageStyle: { marginTop: '1em', height: '15em' },
};
export default style;
